var map = {
	"./10_nuts.png": 2508,
	"./1drink_12beer.png": 2509,
	"./1serving_8ounces.png": 2510,
	"./1serving_8ounces2.png": 2511,
	"./1serving_8ounces3.png": 2512,
	"./1serving_8ounces4.png": 2513,
	"./1serving_8ounces5.png": 2514,
	"./8ounces_1glass.png": 2515,
	"./can_1.png": 2516,
	"./can_2.png": 2517,
	"./can_3.png": 2518,
	"./cup.png": 2519,
	"./dried_serving_1/4cup.png": 2520,
	"./dried_serving_1:4cup.png": 2521,
	"./fresh_serving_1cup.png": 2522,
	"./glass_1.png": 2523,
	"./glass_2.png": 2524,
	"./golfball.png": 2525,
	"./halfthumb.png": 2526,
	"./hand_1.png": 2527,
	"./hand_2.png": 2528,
	"./hand_3.png": 2529,
	"./hand_4.png": 2530,
	"./hand_5.png": 2531,
	"./how.png": 864,
	"./serving_1/2cup.png": 2532,
	"./serving_1:2cup.png": 2533,
	"./serving_1tbsp.png": 2534,
	"./serving_3/4ounces.png": 2535,
	"./serving_3:4ounces.png": 2536,
	"./thumbx2.png": 2537,
	"./usda.png": 2538,
	"./vegetables_1cup.png": 2539,
	"./what.png": 862,
	"./wholethumb.png": 2540,
	"./why.png": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2507;